export const REJECT = 'reject';
export const APPROVE = 'approve';
export const REJECT_SERVER_ERROR = 'reject_server_error';
export const VALIDATION_SERVER_ERROR = 'validation_server_error';
export const VALIDATION_SERVER_APPROVE_ERROR = 'validation_server_approve_error';